<template>
    <cod-dialog
        :show.sync="showDialog"
        back-icon="fal fa-arrow-left"
        max-width="500px"
    >
        <!-- Header -->
        <div slot="header">
            {{ $tc('general.terminal', 1) }}
        </div>

        <!-- Content -->
        <div class="pa-5" slot="content">
            <v-text-field
                v-model="form.name"
                :error-messages="form.$errors.name"
                :label="$t('terminals.name')"
                @blur="form.validate('name')"
                @input="delete form.$errors.name"
            />

            <v-select
                v-model="form.type"
                :error-messages="form.$errors.type"
                :items="terminalTypes"
                :label="$t('terminals.type')"
                item-text="display"
                item-value="value"
                clear-icon="fal fa-times"
                :disabled="!!form.id"
            />

            <v-select
                v-if="item?.type === 'orderingDevice'"
                v-model="form.cash_register_id"
                :error-messages="form.$errors.cash_register_id"
                :items="cashRegisters"
                :label="$t('general.cash_register')"
                :item-text="item => item.getFullName()"
                item-value="id"
                clear-icon="fal fa-times"
                :disabled="!!form.id"
            />
        </div>

        <template slot="footer">
            <v-btn
                class="flex-1 mr-1"
                outlined
                color="primary"
                @click="showDialog = false"
            >
                {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
                class="flex-1 ml-1"
                color="primary"
                depressed
                :disabled="form.$busy"
                :loading="form.$busy"
                @click="save()"
            >
                {{ $t('general.save') }}
            </v-btn>
        </template>
    </cod-dialog>
</template>

<script>
import ApiService from '@/services/ApiService';
import CodDialog from '@/components/CodDialog';
import Terminal from '@/models/Terminal';
import { required, requiredIf } from 'vuelidate/lib/validators';

export default {
    components: {
        CodDialog
    },

    props: {
        show: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: null
        },
        cashRegisters: {
            type: Array,
            default: () => []
        }
    },

    data() {
        return {
            showDialog: false,
            form: this.createForm(),
            terminalTypes: [
                { value: Terminal.TYPE_CASH_REGISTER, display: this.$t('terminals.cash_register') },
                { value: Terminal.TYPE_ORDERING_DEVICE, display: this.$t('terminals.ordering_device') },
                { value: Terminal.TYPE_KITCHEN_DISPLAY_SYSTEM, display: this.$t('terminals.kitchen_display_system') },
            ]
        }
    },

    validations: {
        form: {
            cash_register_id: { requiredIf: requiredIf(form => form.type === Terminal.TYPE_ORDERING_DEVICE) },
            name: { required },
        }
    },

    watch: {
        show(val) {
            this.showDialog = val;
            this.form = this.createForm();
        },

        showDialog(val) {
            this.$emit('update:show', val);
        },
    },

    methods: {
        createForm() {
            return new Form(this, 'form', {
                id: this.item?.id || null,
                cash_register_id: this.item ? this.item.cash_register_id : null,
                name: this.item ? this.item.name : null,
                key: this.item?.key || null,
                type: this.item?.type || null,
                uuid: this.item ? this.item.uuid : this.device?.uuid,
                platform: this.item ? this.item.platform : this.device?.platform,
                model: this.item ? this.item.model : this.device?.model,
                manufacturer: this.item ? this.item.manufacturer : this.device?.manufacturer,
            })
        },

        async save() {
            if(!this.form.validate()) return;

            const method = !this.form.id ? 'post' : 'patch';
            const url = '/admin/terminals' + (this.form.id ? `/${this.form.id}` : '');

            try {
                const response = await ApiService[method](url, this.form)
                this.showDialog = false;
                this.$emit('save', response.data.terminal)
                this.$snackbar(this.$t('terminals.saved'), 'success');
            } catch (error) {
                if(this.form.$errors.name?.length || this.form.$errors.cash_register_id?.length) return

                if(this.form.$errors.uuid?.length) {
                    this.form.setErrors({ name: [this.$t('terminals.already_registered')] })
                }
            }
        },
    }
};
</script>

<style lang="scss" scoped>
</style>
